'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  font-size:16px;\n  font-family:"Open Sans Semibold", arial;\n  color:', ';\n  margin:1em 0;\n'], ['\n  font-size:16px;\n  font-family:"Open Sans Semibold", arial;\n  color:', ';\n  margin:1em 0;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _iaReact = require('ia.react.colorlist');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var H3 = _styledComponents2.default.h3(_templateObject, _iaReact.COLORS.grey6);

exports.default = H3;